"use strict";

exports.__esModule = true;
exports.PgTrendLine = void 0;
var _react = _interopRequireDefault(require("react"));
var _ComboChart = require("../../Charts/ComboChart");
var _scales = require("../../Charts/scales");
var _Series = require("../../Charts/Series");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var getSeries = function getSeries(rowValues) {
  return rowValues.map(function (value, index) {
    return {
      x: index,
      y: value
    };
  });
};
var PgTrendLine = exports.PgTrendLine = function PgTrendLine(_ref) {
  var width = _ref.width,
    rowValues = _ref.rowValues,
    color = _ref.color;
  return /*#__PURE__*/_react["default"].createElement(_ComboChart.ComboChart, {
    "data-testid": "PgTrendLine",
    width: width - 15,
    height: 24,
    padding: 0,
    showXAxis: false,
    showYAxis: false,
    createXScale: _scales.createLinearScale,
    orientation: "vertical",
    series: [{
      data: getSeries(rowValues),
      render: function render(props) {
        return /*#__PURE__*/_react["default"].createElement(_Series.LineChartSeries, _extends({
          color: color
        }, props, {
          curve: "linear"
        }));
      }
    }]
  });
};